module.exports = __webpack_public_path__ + "static/media/bg-transformation-areas.min.b52c7d7f.webp";